import { GridOptions } from 'ag-grid-community'
import { ProductSector, Collateral, Product } from 'api'
import * as constants from 'view/styles/constants'

export interface CollateralBasketProductsPanelGridRow {
  rowId: string
  collateral: Collateral | null
  collaterals: Collateral[] | null
  productSector: ProductSector | null
  product: Product | null
  selected: boolean
}

export const baseRowStyle: GridOptions['rowStyle'] = {
  background: `${constants.CORE_PRIMARY}`,
  padding: '0 6px',
  borderBottom: '1px solid #e1e3e7',
  borderRight: '1px solid #e1e3e7'
}
